import { RestaurantMembershipType } from '../features/restaurant-detail-page/patterns/02-organisms/restaurant-info-modal/membership.tsx';
import {
  RestaurantDetails_getRestaurantDetails_partnerSettingsLivebooking,
  RestaurantDetails_getRestaurantDetails_partnerSettingsOpentable,
  RestaurantDetails_getRestaurantDetails_partnerSettingsQuandoo,
  RestaurantInfoModalReservation_getRestaurantDetails
} from '../types/graphql-types-generated.ts';
import { Paths } from './paths.ts';

export type ReservationPartner = {
  LIVEBOOKING: 'Livebooking';
  QUANDOO: 'Quandoo';
  OPENTABLE: 'OpenTable';
  SPEISEKARTE: 'Speisekarte';
};

const speisekarteBooking = (
  details: RestaurantInfoModalReservation_getRestaurantDetails
): boolean => {
  const hasTableBooking = details.hasTableBooking ?? false;
  const tableBookingSettings = details.tableBookingSettings ?? null;

  return (
    hasTableBooking && tableBookingSettings?.initialSetupDone && tableBookingSettings?.isEnabled
  );
};

export const hasReservation = (
  details: RestaurantInfoModalReservation_getRestaurantDetails
): boolean => {
  const hasPartnerSettingsLivebookings = details.partnerSettingsQuandoo?.id != null;
  const hasPartnerSettingsQuandoo = details.partnerSettingsOpentable?.id != null;
  const hasPartnerSettingsOpentable = details.partnerSettingsLivebooking?.id != null;
  const hasSpeisekarteBooking = speisekarteBooking(details);
  const restaurantPermanentClosed = details.membershipType === RestaurantMembershipType.CLOSED;

  return (
    (hasPartnerSettingsLivebookings ||
      hasPartnerSettingsQuandoo ||
      hasPartnerSettingsOpentable ||
      hasSpeisekarteBooking) &&
    !restaurantPermanentClosed
  );
};

export class Reservation {
  private details: RestaurantInfoModalReservation_getRestaurantDetails;
  public partner: ReservationPartner;

  constructor(details: RestaurantInfoModalReservation_getRestaurantDetails) {
    this.details = details;
    this.partner = {
      LIVEBOOKING: 'Livebooking',
      QUANDOO: 'Quandoo',
      OPENTABLE: 'OpenTable',
      SPEISEKARTE: 'Speisekarte'
    };
  }

  get hasReservation(): boolean {
    return hasReservation(this.details);
  }

  get reservationUrl(): string {
    return `${Paths.rdp(this.details)}/tischreservierung`;
  }

  get partnerSettingsLivebookings(): RestaurantDetails_getRestaurantDetails_partnerSettingsLivebooking | null {
    return this.details.partnerSettingsLivebooking ?? null;
  }

  get partnerSettingsQuandoo(): RestaurantDetails_getRestaurantDetails_partnerSettingsQuandoo | null {
    return this.details.partnerSettingsQuandoo ?? null;
  }

  get partnerSettingsOpentable(): RestaurantDetails_getRestaurantDetails_partnerSettingsOpentable | null {
    return this.details.partnerSettingsOpentable ?? null;
  }

  get speisekarteTableBooking(): boolean {
    return speisekarteBooking(this.details);
  }

  get activePartner(): string {
    if (this.partnerSettingsOpentable) {
      return this.partner.OPENTABLE;
    } else if (this.partnerSettingsLivebookings) {
      return this.partner.LIVEBOOKING;
    } else if (this.partnerSettingsQuandoo) {
      return this.partner.QUANDOO;
    } else if (this.speisekarteTableBooking) {
      return this.partner.SPEISEKARTE;
    }
    return '';
  }
}
